module.exports = __webpack_public_path__ + "static/img/75016J_1_R_20201130_LC.b8301ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/75016J_1_R_20201130_LC.png
// module id = xAi2
// module chunks = 0